import React from "react";
import { graphql } from "gatsby";
import { Accent } from "./Accent";
import { getComponentSettings } from "../../../lib/componentSettings";
import {
  KontentComponentSettings,
  KontentLinkedVectorArt,
  KontentMultiChoice,
  MarginPaddingSizes,
} from "../../../types";
import { formatVector } from "../../../lib/images";
import { getMultiChoice } from "../../../lib/multichoice";

export type AccentAlignments = "left" | "right" | "center";
interface Props extends KontentComponentSettings {
  vector: KontentLinkedVectorArt;
  alignment: KontentMultiChoice<AccentAlignments>;
  height: KontentMultiChoice<MarginPaddingSizes>;
  vertical_margins__margin_bottom: KontentMultiChoice<MarginPaddingSizes>;
  vertical_margins__margin_top: KontentMultiChoice<MarginPaddingSizes>;
  vertical_padding__padding_bottom: KontentMultiChoice<MarginPaddingSizes>;
  vertical_padding__padding_top: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_margins__margin_left: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_margins__margin_right: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_padding__padding_left: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_padding__padding_right: KontentMultiChoice<MarginPaddingSizes>;
}

const AccentContainer: React.FC<Props> = ({
  vector,
  alignment,
  height,
  vertical_margins__margin_bottom,
  vertical_margins__margin_top,
  horizontal_margins__margin_left,
  horizontal_margins__margin_right,
  vertical_padding__padding_bottom,
  vertical_padding__padding_top,
  horizontal_padding__padding_left,
  horizontal_padding__padding_right,
  ...props
}) => {
  const settings = getComponentSettings({ ...props });

  const vectorArt = formatVector(vector.value[0].elements);

  return (
    <Accent
      vector={vectorArt}
      alignment={getMultiChoice(alignment)}
      height={getMultiChoice(height)}
      margin={{
        top: getMultiChoice(vertical_margins__margin_top),
        right: getMultiChoice(horizontal_margins__margin_right),
        bottom: getMultiChoice(vertical_margins__margin_bottom),
        left: getMultiChoice(horizontal_margins__margin_left),
      }}
      padding={{
        top: getMultiChoice(vertical_padding__padding_top),
        right: getMultiChoice(horizontal_padding__padding_right),
        bottom: getMultiChoice(vertical_padding__padding_bottom),
        left: getMultiChoice(horizontal_padding__padding_left),
      }}
      {...settings}
    ></Accent>
  );
};

export default AccentContainer;

export const fragmentAccentContainer = graphql`
  fragment Accent on kontent_item_accent {
    elements {
      vector {
        value {
          ...kontentVectorArt
        }
      }
      alignment {
        value {
          codename
        }
      }
      height {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      horizontal_margins__margin_left {
        value {
          codename
        }
      }
      horizontal_margins__margin_right {
        value {
          codename
        }
      }
      horizontal_padding__padding_left {
        value {
          codename
        }
      }
      horizontal_padding__padding_right {
        value {
          codename
        }
      }
      vertical_padding__padding_top {
        value {
          codename
        }
      }
      vertical_padding__padding_bottom {
        value {
          codename
        }
      }
      vertical_margins__margin_top {
        value {
          codename
        }
      }
      vertical_margins__margin_bottom {
        value {
          codename
        }
      }
    }
  }
`;
